import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsEmptyValidator {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_empty_value" />
  }

  validate() {
    if (
      this.value === undefined ||
      this.value === null ||
      this.value === false ||
      (typeof this.value === 'object' &&
        Object.keys(this.value).length === 0) ||
      (typeof this.value === 'string' && this.value.trim().length === 0)
    ) {
      return this.errorMessage
    }

    return null
  }
}
